const TIPS_BY_TYPE = {
  nature: [
    'Metis dice: alza lo sguardo — i panorami valgono ogni passo.',
    'Porta acqua e scarpe comode: io tengo il ritmo, tu goditi il sentiero.',
    'Se il cielo si copre, il bosco ha un fascino tutto suo. Non mollare.',
  ],
  water: [
    'Metis dice: costume e asciugamano in borsa — il lago aspetta solo te.',
    'La luce del mattino sull\'acqua è magica. Vale la pena svegliarsi un po’ prima.',
    'Zona umida = zanzare possibili. Uno spray in più non guasta mai.',
  ],
  city: [
    'Metis dice: in città cammina senza fretta — i dettagli si scoprono a piedi.',
    'Una pausa al bar con vista è sempre una buona idea tra una tappa e l’altra.',
    'Parcheggio in centro può essere un rompicapo: segui le pillole 🚗.',
  ],
  relax: [
    'Metis dice: oggi il programma è non avere fretta. Respira.',
    'Giornata lenta = energie per domani. Io approvo.',
    'Un libro, un gelato, un panorama: tre ingredienti perfetti.',
  ],
  transfer: [
    'Metis dice: in viaggio tieni snack e documenti a portata di mano.',
    'Controlla orari e parcheggi prima di partire — meno stress, più strada.',
    'Le soste lungo il tragitto sono metà del divertimento.',
  ],
};

const TIPS_DEFAULT = [
  'Metis dice: ogni giorno ha il suo ritmo — segui le pillole e goditi il viaggio.',
  'Se qualcosa non torna, aggiorna le note: il gruppo ti segue in tempo reale.',
  'Un consiglio semplice: partire leggeri, tornare con bei ricordi.',
];

function hashDayKey(dayKey) {
  return String(dayKey).split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
}

export function metisTipForDay(day, dayKey) {
  const pool = TIPS_BY_TYPE[day.day_type] ?? TIPS_DEFAULT;
  return pool[hashDayKey(dayKey) % pool.length];
}
